import React from 'react';
import {ThemedView, ThemedText} from '@app/theme';
import Button from '@sharedComponents/Button/Button';
import BottomSheetContainer from '@sharedComponents/Bottomsheet/Bottomsheet';
import SystemWarning from "../../../../../assets/Icons/SystemWarning";

interface KYCUpdateConfirmationModalProps {
  isVisible: boolean;
  onClose: () => void;
  handleKYCUpdate: () => void;
  colors: any;
}

const KYCUpdateConfirmationModal: React.FC<KYCUpdateConfirmationModalProps> = ({
  isVisible,
  onClose,
  handleKYCUpdate,
  colors,
}) => {
  return (
    <BottomSheetContainer
      isVisible={isVisible}
      close={onClose}
      onClose={onClose}
      dragComponent={null}
      borderTopRightRadius={10}
      borderTopLeftRadius={10}
      containsTextInput
      containerStyle={{backgroundColor: '#fefefe'}}
      showCloseIcon={true}
    >
      <ThemedView alignItems={"center"} padding={"lg"}>
        <SystemWarning/>
        <ThemedText mt={"2xl"} variant={"h5s"} mb={"sm"} textAlign={"center"}>
          {"Are you sure you want to update\nyour KYC details?"}
        </ThemedText>
        <ThemedText variant={"b3r"} textAlign={"center"} mt={"md"} mb={"2xl"}>
          You will need to fetch your latest documents from DigiLocker.
        </ThemedText>
        <Button
          label="Yes, proceed with DigiLocker"
          type="SOLID"
          size='MD'
          disabled={false}
          handlePress={handleKYCUpdate}
          bg={'bg-action-primary'}
          textColor={colors['text-primary']}
        />
        <ThemedView mt={"sm"} flex={1} width={"100%"}>
          <Button
            label="Go back"
            type="OUTLINED"
            size='MD'
            disabled={false}
            handlePress={onClose}
            bg={'bg-action-primary'}
            textColor={colors['text-primary']}
          />
        </ThemedView>
      </ThemedView>
    </BottomSheetContainer>
  );
};

export default KYCUpdateConfirmationModal; 